import { useSubscription } from '@apollo/client'
import onDataLoading from 'Shared/Subscriptions/onDataLoading'

export const useDataLoadingSubscription = scope => {
  const { data } = useSubscription(onDataLoading, { variables: { scope } })
  const percentage = data?.dataLoading?.percentage || 0

  return { isCompleted: percentage === 100, percentage }
}
